<template>
  <div>
    <b-card>
      <title-text />
      <content-text />
    </b-card>
    <image-card />
  </div>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Laboratory_educations/elements/TitleText.vue'
import ContentText from '@/views/Admin/Laboratory_educations/elements/ContentText.vue'
import ImageCard from '@/views/Admin/Laboratory_educations/elements/ImageCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleText,
    ContentText,
    ImageCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['laboratoryEducations/dataItem']
    },
  },
}
</script>
